export function lastItem(arr) {
  return arr[arr.length - 1];
}
export function toNonNullable(arr) {
  if (!arr) {
    return [];
  }
  return arr.filter((x) => !!x);
}
export function keysOf(record) {
  if (!record) {
    return [];
  }
  return Object.keys(record);
}
export function sortByPosition(dir) {
  if (dir === "ASC") {
    return (a, b) => (a?.position || 0) - (b?.position || 0);
  }
  return (a, b) => (b?.position || 0) - (a?.position || 0);
}
export const sortByPositionAsc = sortByPosition("ASC");
export function toNonDuplicateArrayBy(arr, key) {
  if (!arr) {
    return [];
  }
  return [
    ...new Map(toNonNullable(arr).map((item) => [item[key], item])).values()
  ];
}
export function clamp(min, max, value) {
  return Math.min(Math.max(value, min), max);
}
export function extractValue(input) {
  if (input && input.value) {
    return input.value;
  }
  return input;
}
